module.exports = __webpack_public_path__ + "img/culture_img7_.eeb80afa.jpg";